import api from './axios';
import { resolveAssetUrl } from '../utils/assetUrl';

export const adminTutorialVideoApi = {
  list: (params = {}) => api.get('/admin/tutorial-videos', { params }).then((r) => r.data),
  getById: (id) => api.get(`/admin/tutorial-videos/${id}`).then((r) => r.data),
  create: (data) => api.post('/admin/tutorial-videos', data).then((r) => r.data),
  update: (id, data) => api.patch(`/admin/tutorial-videos/${id}`, data).then((r) => r.data),
  deactivate: (id) => api.delete(`/admin/tutorial-videos/${id}`).then((r) => r.data),
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/admin/tutorial-videos/upload', formData).then((r) => {
      const body = r.data;
      if (!body?.success || !body?.data) return body;
      const storagePath = body.data.storagePath || body.data.url || '';
      return {
        ...body,
        data: {
          ...body.data,
          url: resolveAssetUrl(storagePath),
          storagePath,
        },
      };
    });
  },
};
